import { search } from "../search/search.js";
import { KlevuTypeOfRecord, } from "../../index.js";
/**
 * Create a trending products search query. Id for this query is `trendingProducts`
 *
 * @category Query
 * @param options {@link search}
 * @returns See {@link KlevuFetchFunction}
 *
 * @example Simple example
 * ```
 * const result = await KlevuFetch(
 *  trendingProducts()
 * )
 *
 * console.log(result.getQueries("trendingProducts").records)
 * ```
 */
export function trendingProducts(options, ...modifiers) {
    return search("*", Object.assign({ id: "trendingProducts", typeOfRecords: [KlevuTypeOfRecord.Product] }, options), ...modifiers);
}
